import ActionSheet from "actionsheet-react";
import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";
import { logoutState } from "../slices/AuthSlice";
import { addS3Url } from "../utils/modules";
import Menu from "../widgets/Menu";

const AuthHeader = () => {
  const navigate = useNavigate();
  const ref = useRef();
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    ref.current?.close();
  }, [location]);

  useEffect(() => {
    const handleClose = () => {
      ref.current?.close();
    };

    window.addEventListener("scroll", handleClose);
    window.addEventListener("wheel", handleClose);

    return () => {
      window.removeEventListener("wheel", handleClose);
      window.removeEventListener("scroll", handleClose);
    };
  }, []);

  const handleOpen = () => {
    ref.current.open();
  };

  const handleSupportClick = () => {
    ref.current.close();
    const email = "support@freelanz.app";
    const subject = "Help & Support";

    const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}`;

    window.location.href = mailtoLink;
  };

  const actionData = [
    {
      id: 1,
      title: "Support",
      image: addS3Url("/courses/support.svg"),
      handleClick: handleSupportClick,
    },
    {
      id: 2,
      title: "Terms of Service",
      image: addS3Url("/courses/info.svg"),
      handleClick: () => {
        window.scrollTo(0, 0);
        navigate("/terms");
      },
    },
    {
      id: 3,
      title: "Privacy Policy",
      image: addS3Url("/courses/info.svg"),
      handleClick: () => {
        window.scrollTo(0, 0);
        navigate("/privacy");
      },
    },
    {
      id: 4,
      title: "Manage Subscription",
      image: addS3Url("/courses/manage.svg"),
      handleClick: () => {
        window.scrollTo(0, 0);
        navigate("/subscription");
      },
    },
    {
      id: 5,
      title: "Logout",
      image: addS3Url("/courses/logout.svg"),
      handleClick: () => {
        dispatch(logoutState());
        navigate("/login");
      },
    },
  ];

  return (
    <div className="px-2">
      <Menu onClick={handleOpen} />
      <div>
        <ActionSheet
          closeOnBgTap
          ref={ref}
          className="actionSheet"
          bgStyle={{
            backgroundColor: "transparent",
          }}
          sheetStyle={{
            backgroundColor: "#000000",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            maxWidth: "100%",
            margin: "0 auto",
            right: 0,
          }}
          bgTransition="opacity 0.3s ease-in-out"
          sheetTransition="transform 0.3s ease-in-out"
        >
          <div
            id="actionSheetCompo"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "flex-start",
              padding: "15px 15px",
            }}
          >
            <ListMenu arrayData={actionData} />
          </div>
        </ActionSheet>
      </div>
    </div>
  );
};

export default AuthHeader;

const ListMenu = ({ arrayData }) => {
  return (
    <>
      {arrayData.map((d) => (
        <div
          className="d-flex flex-row mt-2 mb-2 align-items-center"
          key={d?.id}
          onClick={d?.handleClick}
        >
          <img className="mx-3" alt="" src={d?.image} height={30} width={30} />
          <p className="m-0 p-0 text-white" style={{ fontSize: "14px" }}>
            {d?.title}
          </p>
        </div>
      ))}
    </>
  );
};
